import styled from 'styled-components';
import { heightMix, marginMix, paddingMix, widthMix } from './mixins';

type StyledFlexContainerProps = {
    $direction?: 'column' | 'row' | 'row-reverse';
    $justify?:
        | 'stretch'
        | 'start'
        | 'center'
        | 'end'
        | 'space-around'
        | 'space-between'
        | 'space-evenly'
        | 'flex-start'
        | 'flex-end'
        | 'left'
        | 'right';
    $align?: 'stretch' | 'start' | 'center' | 'end' | 'baseline';
    $gap?: string;
    $flex?: string;
    $width?: string;
    $height?: string;
    $margin?: string;
};

type StyledLandingContainerProps = StyledFlexContainerProps & {
    $padding?: string;
    $background?: string;
};

export const StyledFlexContainer = styled.div<StyledFlexContainerProps>`
    display: flex;
    flex-direction: ${({ $direction }) => $direction || 'row'};
    justify-content: ${({ $justify }) => $justify || 'flex-start'};
    align-items: ${({ $align }) => $align || 'normal'};
    gap: ${({ $gap }) => $gap || 'normal normal'};
    flex: ${({ $flex }) => $flex || '0 1 auto'};
    ${({ $height }) => $height && heightMix($height)}
    ${({ $width }) => $width && widthMix($width)}
    ${({ $margin }) => $margin && marginMix($margin)}
`;

export const StyledContentContainer = styled(StyledFlexContainer)`
    max-width: 1030px;
`;

export const StyledLandingContainer = styled(StyledFlexContainer)<StyledLandingContainerProps>`
    ${({ $padding }) => $padding && paddingMix($padding)}
    background: ${({ $background }) => $background || 'unset'};
`;
